import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
 Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Note: These tests rely on the following markup defined in /jest/jest-setup-file.js:
 <div id="root" data-app-container=""><div data-page-container=""></div></div>
 */
import React from 'react';
import PropTypes from 'prop-types';
import usePropDelay from '../use-prop-delay/use-prop-delay';

var getJoinedMessages = function getJoinedMessages(messages) {
  return Object.keys(messages).map(function (key) {
    return messages[key];
  }).join(' ');
}; // The delay functionality addresses an issue in VoiceOver
// in which updates to message content are not recognized.


var AriaMessageBlock = function AriaMessageBlock(_ref) {
  var _ref$messages = _ref.messages,
      messages = _ref$messages === void 0 ? [] : _ref$messages,
      rest = _objectWithoutProperties(_ref, ["messages"]);

  var delay = messages.size ? 250 : 0;
  var content = usePropDelay({
    start: '',
    end: getJoinedMessages(messages.toJS()),
    delay: delay
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "visuallyHidden",
    "aria-atomic": "true"
  }, rest), content);
};

AriaMessageBlock.propTypes = {
  messages: PropTypes.object.isRequired
};
export default AriaMessageBlock;